/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/header.service.ts                                       */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Jul 31 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Injectable } from '@angular/core';
import { User } from '@siag/js-egov-authentication';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { RootState } from '../../../stores/states/root/state';
import { Store } from '@ngrx/store';
import { getCurrentLanguage, getLoggedUser } from '../../../stores/selectors/ui/selectors';
import { combineLatest } from 'rxjs';

/**
 * The geo file type service
 */
@Injectable({
    providedIn: 'root'
})
export class HeaderService {

    /**
     * The current user set by egov
     */
    userCurrent: User | any;
    /**
     * The current lang
     */
    currentLang: string;

    /**
     * The constructor
     */
    constructor(private store: Store<RootState>) {
        // tslint:disable-next-line
        const currentLanguage$ = this.store.select(getCurrentLanguage);
        // tslint:disable-next-line
        const currentUser$ = this.store.select(getLoggedUser);
        // tslint:disable-next-line
        combineLatest(
            currentLanguage$,
            currentUser$
        ).subscribe((responses) => {
            const language = responses[0];
            const user = responses[1];
            this.userCurrent = user;
            this.currentLang = language.isoCode === 'en' ? environment.defaultLanguage : language.isoCode;
        });
    }


    /**
     * Return the egov headers
     */
    getHeaders() {
        if (!this.userCurrent) {
            return {};
        }

        if (!environment.production) {
            return {
                headers: {
                    'X-NewPlan-Locale': this.currentLang,
                    'Usr-UserName': this.userCurrent.username
                        ? this.userCurrent.username
                        : undefined,
                    'Usr-FirstName': this.userCurrent.owner && this.userCurrent.owner.firstname
                        ? this.userCurrent.owner.firstname
                        : undefined,
                    'Usr-LastName': this.userCurrent.owner && this.userCurrent.owner.lastname
                        ? this.userCurrent.owner.lastname
                        : undefined,
                    'Usr-Email': this.userCurrent.delegations && this.userCurrent.delegations.length > 0 && this.userCurrent.delegations[0].email
                        ? this.userCurrent.delegations[0].email
                        : undefined,
                    'Usr-IsoCodeLang': this.userCurrent.language
                        ? this.userCurrent.language.toLowerCase()
                        : undefined,
                    'Usr-BirthDate': this.userCurrent.delegations &&
                        this.userCurrent.delegations.length > 0 &&
                        this.userCurrent.delegations[0] &&
                        this.userCurrent.delegations[0].represented &&
                        this.userCurrent.delegations[0].represented.naturalPerson &&
                        (this.userCurrent.delegations[0].represented.naturalPerson as any).birthDate
                        ? moment((this.userCurrent.delegations[0].represented.naturalPerson as any).birthDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY')
                        : undefined,
                    'Usr-FiscalCode': this.userCurrent.delegations &&
                        this.userCurrent.delegations.length > 0 &&
                        this.userCurrent.delegations[0] &&
                        this.userCurrent.delegations[0].represented &&
                        this.userCurrent.delegations[0].represented.naturalPerson &&
                        (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                        ? (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                        : undefined,
                    'Usr-Vat': this.userCurrent.delegations &&
                        this.userCurrent.delegations.length > 0 &&
                        this.userCurrent.delegations[0] &&
                        this.userCurrent.delegations[0].represented &&
                        this.userCurrent.delegations[0].represented.naturalPerson &&
                        (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                        ? (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode.substring(0, 10)
                        : undefined,
                    /*'Usr-Phone': this.userCurrent.delegations &&
                        this.userCurrent.delegations.length > 0 &&
                        this.userCurrent.delegations[0] &&
                        (this.userCurrent.delegations[0] as any).phone
                        ? (this.userCurrent.delegations[0] as any).phone
                        : undefined,*/
                    'Usr-IsExt': 'true'
                }
            };
        }

        return {
            headers: {
                'X-NewPlan-Locale': this.currentLang
            }
            /* 
            'Usr-UserName': this.userCurrent.username
                    ? this.userCurrent.username
                    : undefined,
                'Usr-FirstName': this.userCurrent.owner && this.userCurrent.owner.firstname
                    ? this.userCurrent.owner.firstname
                    : undefined,
                'Usr-LastName': this.userCurrent.owner && this.userCurrent.owner.lastname
                    ? this.userCurrent.owner.lastname
                    : undefined,
                'Usr-Email': this.userCurrent.delegations && this.userCurrent.delegations.length > 0 && this.userCurrent.delegations[0].email
                    ? this.userCurrent.delegations[0].email
                    : undefined,
                'Usr-IsoCodeLang': this.userCurrent.language
                    ? this.userCurrent.language.toLowerCase()
                    : undefined,
                'Usr-BirthDate': this.userCurrent.delegations &&
                    this.userCurrent.delegations.length > 0 &&
                    this.userCurrent.delegations[0] &&
                    this.userCurrent.delegations[0].represented &&
                    this.userCurrent.delegations[0].represented.naturalPerson &&
                    (this.userCurrent.delegations[0].represented.naturalPerson as any).birthDate
                    ? moment((this.userCurrent.delegations[0].represented.naturalPerson as any).birthDate, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY')
                    : undefined,
                'Usr-FiscalCode': this.userCurrent.delegations &&
                    this.userCurrent.delegations.length > 0 &&
                    this.userCurrent.delegations[0] &&
                    this.userCurrent.delegations[0].represented &&
                    this.userCurrent.delegations[0].represented.naturalPerson &&
                    (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                    ? (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                    : undefined,
                'Usr-Vat': this.userCurrent.delegations &&
                    this.userCurrent.delegations.length > 0 &&
                    this.userCurrent.delegations[0] &&
                    this.userCurrent.delegations[0].represented &&
                    this.userCurrent.delegations[0].represented.naturalPerson &&
                    (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                    ? (this.userCurrent.delegations[0].represented.naturalPerson as any).fiscalCode
                    : undefined,            
                'Usr-IsExt': 'true'
                       
                            'Usr-Phone': this.userCurrent.delegations &&
                                this.userCurrent.delegations.length > 0 &&
                                this.userCurrent.delegations[0] &&
                                (this.userCurrent.delegations[0] as any).phone
                                ? (this.userCurrent.delegations[0] as any).phone
                                : undefined, */
        };
    }
}
